import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type SliceAnalyticsOverviewBarState = {
  isOpen: boolean;
};

const initialState: SliceAnalyticsOverviewBarState = {
  isOpen: false,
};

const slice = createSlice({
  name: "analyticsOverviewBar",
  initialState,
  reducers: {
    setAnalyticsOverviewBarOpen: (draft, action: PayloadAction<boolean>) => {
      draft.isOpen = action.payload;
    },
  },
});

export const { setAnalyticsOverviewBarOpen } = slice.actions;

export const reducerAnalyticsOverviewBar = slice.reducer;
